module.exports = __webpack_public_path__ + "img/spamhaus-logo-red.47cd7f01.png";